module.exports = __webpack_public_path__ + "d33794c3d455bc47c014e5bb3c421b32.svg";